export const ITEM_LIST_DATA = 'ITEM_LIST_DATA';
export const ITEM_DATA_LOADING = 'ITEM_DATA_LOADING';
export const ITEM_DATA_LIST_ERROR = 'ITEM_DATA_LIST_ERROR';



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/itemlistingreport/state/types.js